import { Component, OnInit } from '@angular/core';

import {Router} from '@angular/router';
import { ActivatedRoute, Params } from '@angular/router';
import {RestapiService} from '../restapi.service';

@Component({
  selector: 'app-user-audit',
  templateUrl: './user-audit.component.html',
  styleUrls: ['./user-audit.component.css']
})
export class UserAuditComponent implements OnInit {
  respObject: any;
  uaData: any;
  respComp: any;
  compData: any;

  companyId="";

  perPageRow = this._rest.PER_PAGE_ROW;
  curPage = 1;
  totalRows = 0;
  pages = [];
  noOfRows=0;

  constructor(private router: Router,private route: ActivatedRoute, private _rest: RestapiService) { }

  ngOnInit(): void {
    const co = {}
    this._rest.companyList(co).subscribe((res) => {
      this.respComp = res;
      this.compData = this.respComp.details;
      //console.log(JSON.stringify(this.respPeer));      
    })
  	this.searchUserAudit(1);
  }
  searchUserAudit(curPage){
    this.curPage = curPage;
    var fd = {};
    
    fd["limit"]=this.perPageRow;
    fd["page"]=this.curPage;
    fd["companyId"]=this.companyId;
    this.route.params.forEach((params: Params) => {
      if(params['id']!=undefined){
        try{
          fd["userId"] = parseInt(params['id']);
        } catch(e){
          fd["userId"] = 0;
        }
      } else {
        fd["userId"] = 0;
      }
      this._rest.getuserAudit(fd).subscribe((res) => {
        this.respObject = res;
        if(this.respObject.error==0){
          this.uaData = this.respObject.resp.data;
          this.totalRows = this.respObject.resp.info;
          this.noOfRows=this.uaData.length;
          this.pages=[];
          for (var i=1;i<=Math.ceil(this.totalRows/this.perPageRow);i++){
            this.pages.push(i);
          }
        } else {
          this.uaData=[];
          this.totalRows = 0;
          this.noOfRows = 0;
          this.pages=[];
        }
      });
    });
  }
}
